exports.components = {
  "component---src-pages-publish-changes-js": () => import("./../../../src/pages/publish-changes.js" /* webpackChunkName: "component---src-pages-publish-changes-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

